/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
document.addEventListener('variant:changed', function(event) {
  //  console.log('variantchanged');
  var variant = event.detail.variant;

  // Handle variant change on Pre-order products
  if ($('#pd-branding').length && variant.available) {
      console.log($('.ProductForm__AddToCart').html(), event);
      $('.ProductForm__AddToCart').html('<span>Pre-order</span><span class="cart_icon"><svg width="100%" viewBox="0 0 24 24"><path d="M0 0h24v24H0V0z" fill="none"></path><path d="M15.55 13c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.37-.66-.11-1.48-.87-1.48H5.21l-.94-2H1v2h2l3.6 7.59-1.35 2.44C4.52 15.37 5.48 17 7 17h12v-2H7l1.1-2h7.45zM6.16 6h12.15l-2.76 5H8.53L6.16 6zM7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zm10 0c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z" fill="currentColor"></path></svg></span>');
  }

  // REMOVE THE OLD LINE ITEM PROPERTIES
  $('#bundles_child_products').html('');

  var bundle_el = $('#bundle_' + variant.id);
  if (bundle_el.length) {
      var json = bundle_el.data('json');
      $.each(json, function(index, value) {
          var itemNo = index + 1;
          var title = value.title;
          var quantity = value.quantity;
          var sku = value.sku;
          var inputName = 'properties[_Product ' + itemNo + ']';
          if (sku != null) {
              var inputValue = quantity + 'x ' + title + ' [' + sku + ']';
          } else {
              var inputValue = quantity + 'x ' + title;
          }

          var lineItemPropertyInput = $("<input />");
          lineItemPropertyInput.attr({
              "class": 'bundles_lineitemProperty',
              "name": inputName,
              "type": "hidden",
              "value": inputValue
          });

          $('#bundles_child_products').append(lineItemPropertyInput);
      });
  }
});

var gwps = null;
document.addEventListener('product:added', function(event) {
  //checkForGWP(false);
});
document.addEventListener('cart:quantityupdated', function(event) {
  //checkForGWP(false);
});
document.addEventListener('cart:contentUpdated', function(event) {
  updateCartStyling();
  setTimeout(updateCartStyling, 200);
});

function includes(container, value) {
  var returnValue = false;
  var pos = container.indexOf(value);
  if (pos >= 0) {
      returnValue = true;
  }
  return returnValue;
}

function updateCart(itemsToAdd, itemsToRemove) {
  jQuery.post('/cart/add.js', {
      items: itemsToAdd
  }, function(data) {
      if (itemsToRemove.length > 0) {
          removeFromCart(itemsToRemove);
      } else {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
              bubbles: true
          }));
      }
  }, "json");
}

function removeFromCart(itemsToRemove) {
  var remove = "";
  $.each(itemsToRemove, function(i, variantId) {
      if (remove.length) {
          remove += "&";
      }
      remove += "updates[" + variantId + "]=0";
  });
  jQuery.post('/cart/update.js', remove, function(data) {
      setTimeout(function() {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
              bubbles: true
          }));
      }, 1000);
  }, "json");
}
var progressMessage = 'Message';
var progressPercent = 0;

function updateCartStyling() {
  var cart_used_height = $('#sidebar-cart .Drawer__Header').outerHeight() + $('#sidebar-cart .Cart__ShippingNotice').outerHeight() + $('#sidebar-cart .Drawer__Footer').outerHeight() + $('#sidebar-cart .upsell-items').outerHeight();
  var remaining_height = $('#sidebar-cart').outerHeight() - cart_used_height;
  console.log('progressPercent', progressPercent);
  console.log('progressMessage', progressMessage);
  var shipping_progress = progressPercent + "%";

  var progress_style = $('#progress-style');
  var progress_bar_style = '.Cart__ItemList { min-height: ' + remaining_height + 'px; } .shipping-progress-amount { width: ' + shipping_progress + '; }';
  if (!progress_style.length) {
      progress_style = $('<style/>').attr({
          id: "progress-style",
          type: "text/css"
      }).appendTo("head");
  }
  progress_style.html(progress_bar_style);
  $('#progress-message').html(progressMessage);

}

function checkSpringBonusPromo(cart) {
  var minSubTotal = 2500;
  var qualifyingPrice = cart.total_price;
  var excludeProducts = [32436327186537, 32436327219305, 32436327252073, 32424140079209];
  $.each(cart.items, function(i, cartItem) {
      if (includes(excludeProducts, cartItem.variant_id)) {
          qualifyingPrice = qualifyingPrice - cartItem.final_line_price;
      }
  });
  if (qualifyingPrice >= minSubTotal) {
      $('body').addClass('spring-bonus-promo');
  } else {
      $('body').removeClass('spring-bonus-promo');
  }
}

function checkForGWP(forceAdd) {

  $('#selectable-popup').hide();


  forceAdd = true;

  if (gwps != null) {

      jQuery.get('/cart?view=gwp', function(data) {

          var cart = JSON.parse(data);

          var gwpsToApply = [];
          var gwpsToRemove = [];
          var gwpsToSelect = [];
          var customerIsPro = $('body.is-pro').length;
          var customerIsPowderProfectionist = $('body.is-powder-perfectionist').length;
          var customerIsDevotedDipper = $('body.is-devoted-dipper').length;
          var customerIsNailNovice = $('body.is-nail-novice').length;
          var showPrompt = false;
          var gwpIsAvailable = false;
          var now = Math.round(new Date().getTime() / 1000);
          var thresholds = [];
          //checkSpringBonusPromo(cart);
          var has_free_shipping = false;
          var gwpCount = 0;
          var gwpLimit = 2;


          var $progressBar = $('#progress-bar');

          if ($progressBar.length) {
              thresholds.push({
                  type: "shipping",
                  threshold: $progressBar.data('threshold')
              });
          }


          $.each(gwps, function(index, gwp) {

              var hasRequiredProduct = gwp.requireProducts.length == 0;
              var requireProductsCount = gwp.requireProductsCount;
              var requireCount = 0;
              var cartHasGWPProduct = false;
              var gwpIsActive = gwp.isActive;
              var qualifyingPrice = cart.total_price;
              var quantityToAdd = gwp.quantity;
              var minSpend = convertCurrency(gwp.minSpend);
              var isSelectable = gwp.isSelectable;

              if (gwpIsActive) {
                  gwpIsActive = (gwp.startDate <= now && gwp.endDate >= now);
              }

              if (gwp.enabledForCustomers.length > 0 && gwpIsActive) {
                  gwpIsActive = false;
                  if (includes(gwp.enabledForCustomers, "nail tech") && customerIsPro) {
                      gwpIsActive = true;
                  }
                  if (includes(gwp.enabledForCustomers, "tier: Powder Perfectionist") && customerIsPowderProfectionist) {
                      gwpIsActive = true;
                  }
                  if (includes(gwp.enabledForCustomers, "tier: Devoted Dipper") && customerIsDevotedDipper) {
                      gwpIsActive = true;
                  }
                  if (includes(gwp.enabledForCustomers, "tier: Nail Novice") && customerIsNailNovice) {
                      gwpIsActive = true;
                  }
              }

              if (gwp.excludeForCustomers.length > 0 && gwpIsActive) {
                  if (includes(gwp.excludeForCustomers, "nail tech") && customerIsPro) {
                      gwpIsActive = false;
                  }
                  if (includes(gwp.excludeForCustomers, "tier: Powder Perfectionist") && customerIsPowderProfectionist) {
                      gwpIsActive = false;
                  }
                  if (includes(gwp.excludeForCustomers, "tier: Devoted Dipper") && customerIsDevotedDipper) {
                      gwpIsActive = false;
                  }
                  if (includes(gwp.excludeForCustomers, "tier: Nail Novice") && customerIsNailNovice) {
                      gwpIsActive = false;
                  }
              }

              if (gwpIsActive) {
                  if (gwp.minSpend > 0 && $progressBar.data('freebie-show-message')) {
                      thresholds.push({
                          type: "gwp",
                          threshold: gwp.minSpend
                      });
                  }
              }



              $.each(cart.items, function(i, cartItem) {
                  console.log('cartItem', cartItem);
                  if (cartItem.variant_id == gwp.variantId) {
                      if (cartItem.quantity >= gwp.quantity) {
                          cartHasGWPProduct = true;
                          gwpCount += cartItem.quantity;
                      } else {
                          cartHasGWPProduct = false;
                          quantityToAdd = gwp.quantity - cartItem.quantity;
                      }
                  }
                  if (!hasRequiredProduct) {
                      if (includes(gwp.requireProducts, cartItem.variant_id)) {
                          requireCount += cartItem.quantity;
                          if (requireCount >= requireProductsCount) {
                              hasRequiredProduct = true;
                          }
                      }
                  }
                  if (includes(gwp.excludeProducts, cartItem.variant_id)) {
                      qualifyingPrice = qualifyingPrice - cartItem.final_line_price;
                  }
                  if (cartItem.free_shipping) {
                      has_free_shipping = true;
                  }
              });


              if (cartHasGWPProduct && gwpCount > gwpLimit) {
                  gwpIsActive = false;
                  gwpsToRemove.push(gwp.variantId);
              } else {
                  if (qualifyingPrice >= minSpend && hasRequiredProduct && gwpIsActive) {
                      if (isSelectable) {
                          if (!cartHasGWPProduct && sessionStorage.getItem('gwpSelectableAdded') != '1') {
                              gwpsToSelect.push({
                                  id: gwp.variantId,
                                  quantity: quantityToAdd,
                                  name: gwp.name,
                                  image: gwp.image
                              });
                          }
                      } else {
                          gwpIsAvailable = true;
                          if (!cartHasGWPProduct && (sessionStorage.getItem('gwpAdded' + gwp.variantId) != '1' || forceAdd)) {
                              sessionStorage.setItem('gwpAdded' + gwp.variantId, '1');
                              gwpsToApply.push({
                                  id: gwp.variantId,
                                  quantity: quantityToAdd
                              });
                          } else if (!cartHasGWPProduct) {
                              showPrompt = true;
                          }
                      }
                  } else {
                      if (cartHasGWPProduct && gwp.removeIfNotQualified) {
                          if (isSelectable) {
                              removeSelectableFreebie();
                          } else {
                              sessionStorage.setItem('gwpAdded' + gwp.variantId, '0');
                          }
                          gwpsToRemove.push(gwp.variantId);
                      }
                  }
              }

          });

          if (gwpsToApply.length > 0) {
              updateCart(gwpsToApply, gwpsToRemove);
          } else if (gwpsToRemove.length > 0) {
              removeFromCart(gwpsToRemove);
          }

          if (!gwpIsAvailable || forceAdd) {
              $('.gift-prompt').remove();
              $('#sidebar-cart').removeClass('has-prompt');
          }

          if (gwpsToSelect.length > 1) {
              var selectablePopUp = $('#selectable-popup').hide();
              var popuphtml = '<div class="selectable-popup-container"> <button class="selectable-popup__close">&times;</button> <div class="Heading u-h2 Center">Choose a free gift!</div> <div id="selectable-products"></div> </div>';
              if (selectablePopUp.length) {
                  selectablePopUp.html(popuphtml);
              } else {
                  selectablePopUp = $('<div/>').attr('id', 'selectable-popup').hide().html(popuphtml).appendTo('body');
              }
              $.each(gwpsToSelect, function(index, selectable) {

                  var productCard = $('<div/>').addClass('selectable-product').appendTo(selectablePopUp.find('#selectable-products'));
                  $('<img/>').attr('src', selectable.image).appendTo(productCard);
                  $('<div/>').addClass('ProductItem__Title Heading').html(selectable.name).appendTo(productCard);
                  var selectBtn = $('<button/>').addClass('Button Button--primary').text('Add Gift').appendTo(productCard);
                  selectBtn.on('click', function() {
                      selectablePopUp.find('.selectable-popup__error').remove();
                      jQuery.getJSON('/cart.js', function(cart) {

                          var proceed = true;

                          $.each(gwpsToSelect, function(i, gwpItem) {
                              var gwpCartItem = cart.items.find(c => c.id == gwpItem.id);
                              if (gwpCartItem) {
                                  proceed = false;
                              }
                          });

                          if (proceed) {
                              jQuery.post('/cart/add.js', {
                                  items: [{
                                      id: selectable.id,
                                      quantity: selectable.quantity,
                                      properties: {
                                          '_freebie': 'Selectable Freebie'
                                      }
                                  }]
                              }, function(data) {
                                  selectablePopUp.hide();
                                  document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                                      bubbles: true
                                  }));
                                  sessionStorage.setItem('gwpSelectableAdded', '1');

                                  $('.gift-prompt').hide();

                                  /*if ( $('#sidebar-cart[aria-hidden="true"]').length ) {
                                    console.log('cartt');
                                    $('#cart-icon').click();
                                  }*/

                              }, "json");
                          } else {
                              sessionStorage.setItem('gwpSelectableAdded', '1');

                              selectablePopUp.find('.selectable-popup-container').append('<div class="selectable-popup__error" style="background: #f94c431a; color: #f94c43; padding: 10px;">You have already selected a freebie. To choose a different option, please first remove the freebie from your cart.</div>');
                              setTimeout(function() {
                                  document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                                      bubbles: true
                                  }));
                              }, 1000)
                              setTimeout(function() {
                                  selectablePopUp.hide();
                              }, 10000)
                              $('.gift-prompt').hide();
                          }

                      });


                  });
              });
              selectablePopUp.find('.selectable-popup__close').on('click', function(e) {
                  selectablePopUp.hide();
                  showSelectableGiftPrompt(selectablePopUp);
              });

              if (sessionStorage.getItem('gwpSelectableShown') != '1') {
                  selectablePopUp.show();
                  sessionStorage.setItem('gwpSelectableShown', '1');
              } else {
                  if (sessionStorage.getItem('gwpSelectableAdded') != '1') {
                      showSelectableGiftPrompt(selectablePopUp);
                  }
              }
          }

          /*if (showPrompt) {
          if (!$('.gift-prompt').length) {
            var $prompt = $('<div/>').addClass('gift-prompt').css('position', 'relative').css('z-index', '99');
            var $promptMessage = $('<p/>').html('Your order qualifies for a free gift!').appendTo($prompt);
            var $vutton = $('<button/>').html('Add gift').appendTo($promptMessage);
            $prompt.insertAfter('.Drawer__Header');
            $('#sidebar-cart').addClass('has-prompt');

            $vutton.on('click', function() {
              checkForGWP(true);
            });
          }
        }*/

          if (thresholds.length) {
              var showGwpMessage = false;
              var showShippingMessage = false;
              var gwpThreshold = false;
              var shippingThreshold = false;
              var prevAmount = 0;
              thresholds.sort(function(a, b) {
                  return parseFloat(a.threshold) - parseFloat(b.threshold);
              });

              var remaining_amount = 0;

              //console.log("has_free_shipping", has_free_shipping);

              $.each(thresholds, function(index, threshold) {
                  //console.log(cart.total_price);
                  if ((cart.total_price < threshold.threshold) && !has_free_shipping) {
                      if (prevAmount == 0 || prevAmount == threshold.threshold) {
                          if (threshold.type == "gwp") {
                              showGwpMessage = true;
                              prevAmount = threshold.threshold;
                          } else {
                              showShippingMessage = true;
                              prevAmount = threshold.threshold;
                          }
                          remaining_amount = threshold.threshold - cart.total_price;
                          progressPercent = (cart.total_price / threshold.threshold) * 100;
                      }
                  } else {
                      if (threshold.type == "gwp") {
                          gwpThreshold = true;
                      } else {
                          shippingThreshold = true;
                      }
                      progressPercent = 100;
                  }




                  /*if (threshold.type == "gwp") {
                    if (cart.total_price > threshold.threshold) {
                      if (threshold.threshold == prevAmount) {
                        console.log('Show combined message');
                      } else {
                        console.log('Show gwp message');
                      }
                    } else {
                      gwpThreshold = true;
                    }
                  } else {
                    if (cart.total_price > threshold.threshold) {
                      if (threshold.threshold == prevAmount) {
                        console.log('Show combined message');
                      } else {
                        console.log('Show shipping message');
                      }
                    } else {
                      shippingThreshold = true;
                    }
                  }*/

              });

              //if (remaining_amount > 0) {
              remaining_amount = Shopify.formatMoney(convertCurrency(remaining_amount), theme.moneyFormat)
              //}
              if (gwpThreshold && shippingThreshold) {
                  progressMessage = $progressBar.data('freebie-shipping-success-message');
                  console.log($progressBar.data('freebie-shipping-success-message'));
              } else if (gwpThreshold && showShippingMessage) {
                  progressMessage = $progressBar.data('freebie-success-shipping-message').replace("[remaining_amount]", remaining_amount).replace(".00", "");
                  console.log($progressBar.data('freebie-success-shipping-message'));
              } else if (shippingThreshold && showGwpMessage) {
                  progressMessage = $progressBar.data('shipping-success-freebie-message').replace("[remaining_amount]", remaining_amount).replace(".00", "");
                  console.log($progressBar.data('shipping-success-freebie-message'));
              } else if (showShippingMessage) {
                  progressMessage = $progressBar.data('shipping-message').replace("[remaining_amount]", remaining_amount).replace(".00", "");
                  console.log($progressBar.data('shipping-message'));
              } else if (showGwpMessage) {
                  progressMessage = $progressBar.data('freebie-message').replace("[remaining_amount]", remaining_amount).replace(".00", "");
                  console.log($progressBar.data('freebie-message'));
              } else if (shippingThreshold) {
                  progressMessage = $progressBar.data('shipping-success');
                  console.log($progressBar.data('shipping-success'));
              } else if (gwpThreshold) {
                  progressMessage = $progressBar.data('freebie-success');
                  console.log($progressBar.data('freebie-success'));
              }

          }

      });

  } else {
      jQuery.getJSON(gwpsUrl, function(data) {
          gwps = data;
          checkForGWP(forceAdd);
      });
  }

}

function showSelectableGiftPrompt(selectablePopUp) {
  if (!$('.gift-prompt').length) {
      var $prompt = $('<div/>').addClass('gift-prompt').css('position', 'relative').css('z-index', '99');
      var $promptMessage = $('<p/>').html('Your order qualifies for a free gift!').appendTo($prompt);
      var $vutton = $('<button/>').html('Choose gift').appendTo($promptMessage);
      $prompt.insertAfter('.Drawer__Header');
      $('#sidebar-cart').addClass('has-prompt');

      $vutton.on('click', function() {
          selectablePopUp.show();
          sessionStorage.setItem('gwpSelectableShown', '1');
      });
  }
}

function removeSelectableFreebie() {
  sessionStorage.removeItem('gwpSelectableAdded');
  sessionStorage.removeItem('gwpSelectableShown');
}

function setCountryMessage(country, nationality, url) {
  var message = '<p class="Heading u-h4">Now shipping to ' + country + '!</p><p>It looks like you’re shopping from ' + country + '. Good news, we now ship worldwide from our US store!</p>';
  message += '<p><button class="Button Button--primary Button--full" data-action="close-modal">Shop now</button></p>';
  $('#modal-eu .Modal__Content').html(message);
}

function isEUCountry(country) {
  var euCountries = ['BE', 'BG', 'DK', 'DE', 'EE', 'FI', 'FR', 'GR', 'IE', 'IT', 'HR', 'LV', 'LT', 'LU', 'MT', 'NL', 'AT', 'PL', 'SE', 'SK', 'SI', 'ES', 'CZ', 'HU', 'GB', 'CY', 'CH'];
  return includes(euCountries, country);
}

function isIntCountry(country) {
  var intCountries = ['US', 'BE', 'BG', 'DK', 'DE', 'EE', 'FI', 'FR', 'GR', 'IE', 'IT', 'HR', 'LV', 'LT', 'LU', 'MT', 'NL', 'AT', 'PL', 'SE', 'SK', 'SI', 'ES', 'CZ', 'HU', 'GB', 'CY', 'CH', 'CA', 'MX'];
  return includes(intCountries, country);
}

function showEUPopUp(country, country_name) {
  //console.log(country, isEUCountry(country));
  if (!isIntCountry(country)) {
      var showMessage = sessionStorage.getItem("intmessage");
      if (showMessage != 'false') {
          sessionStorage.setItem('intmessage', 'false');
          setCountryMessage(country_name, country, 'https://www.revelnail.com/');
          $('#modal-eu-opener').click();
      }
  }
}

function getCountry() {
  var country = sessionStorage.getItem("country");
  if (country === null) {
      jQuery.getJSON('/browsing_context_suggestions.json', function(info) {
          country = info.detected_values.country.handle;
          sessionStorage.setItem('country', country);
          $('body').addClass('country-' + country);
          /*if (country == 'MX') {
            window.location.replace("https://revelnail.mx/");
          } else {*/
          //showEUPopUp(country, info.detected_values.country_name);
          //}
      });
  } else {
      $('body').addClass('country-' + country);
      //showEUPopUp(country);
  }
}

function convertCurrency(price) {
  if (Shopify.currency.active != "USD") {
      var conversionRate = Shopify.currency.rate;
      var convertedPrice = price * conversionRate;
      return convertedPrice;
  } else {
      return price;
  }
}

function updatePricesForCurrency() {
  if (Shopify.currency.active != "USD") {
      $('.is-pro-price, .convert-currency').each(function() {
          var el = $(this);
          var priceToConvert = el.data('rawprice');
          var price = convertCurrency(priceToConvert);
          var finalPrice = Shopify.formatMoney(price, theme.moneyFormat);
          el.html(finalPrice);
      });
  }
}

function checkLoyaltyPrices() {
  if ($('span.lion-currency__value').not('.converted').length) {
      $('span.lion-currency__value').not('.converted').each(function() {
          var price = parseFloat($(this).text().replace('$', ''));
          convertedPrice = convertCurrency(price * 100);
          convertedPrice = Shopify.formatMoney(convertedPrice, theme.moneyFormat);
          $(this).html(convertedPrice).addClass('converted');
      });
      if (!$('#loyalty-currency-styles').length) {
          var tier2 = "Spend " + Shopify.formatMoney(convertCurrency(7500), theme.moneyFormat);
          var tier3 = "Spend " + Shopify.formatMoney(convertCurrency(20000), theme.moneyFormat);
          $('<style type="text/css" id="loyalty-currency-styles">.lion-tier-overview .lion-tier-box--1 .lion-tier-box__title:after { content: "' + tier2 + '"; } .lion-tier-overview .lion-tier-box--2 .lion-tier-box__title:after { content: "' + tier3 + '"; }</style>').appendTo('body');
          $('#loyaltylion').on('click', function() {
              checkLoyaltyPrices();
          });
      }
  } else {
      setTimeout(checkLoyaltyPrices, 250);
  }
}

function checkForRewardCurrency() {
  if ($('#rewards-panel').length) {
      if (Shopify.currency.active != "USD") {
          checkLoyaltyPrices();
      }
  }
}

function upsellAdd(variantId, sku, button, type) {
  $(button).addClass('adding').attr('disabled', 'disabled');
  jQuery.post('/cart/add.js', {
      items: [{
          id: variantId,
          quantity: 1,
          properties: {
              '_tp_upsell': type + ' Upsell'
          }
      }]
  }, function(data) {
      ga("send", {
          hitType: "event",
          eventCategory: 'TP Upsell',
          eventAction: 'Added to Cart',
          eventLabel: sku
      });
      // updateCartStyling();
      document.documentElement.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: {
              variant: variantId,
              quantity: 1
          }
      }));

      if (type == 'Bundle') {
          $(button).removeClass('adding').removeAttr('disabled');
      }
  }, "json");
}

function adjustProductMetaLayout() {
  if ($(window).width() < 768) {
      $('.Product__Gallery').css('padding-top', $('.Product__Info .ProductMeta').height() + 'px');
  } else {
      $('.Product__Gallery').removeAttr('style');
  }
}

function loadBundle() {
  if ($('.bundle-builder-app--bundle--name').length) {
      var productMarkup = $('<div/>').attr('id', 'shopify-section-product-section__main');
      productMarkup.html('<section class="Product Product--small tp-bb-product-wrapper"><div class="Product__Wrapper"><div class="Product__Gallery"></div><div class="Product__InfoWrapper"><div class="Product__Info"><h1 class="ProductMeta__Title Heading u-h2" data-tp-fill="productName"></h1><div class="Container"><div class="tp-bb-price ProductMeta__Price Price Text--subdued u-h4 Heading"></div><div class="tp-bb-instructions">Choose 4 colors to create your own kit!</div><div class="tp-bb-swatches"></div><div class="ProductMeta__Description"><p><b>What it is:</b> Build your own kit! Every kit contains all the EZ Care liquid you need, plus four 0.5oz jars in the colors of your choice!</p></div><div class="tp-bb-add-to-bag"></div></div></div></div></div></section>');

      var bundleName = $('.bundle-builder-app--bundle--name').text();
      if (bundleName == 'Bare With Me Kit') {
          $('body').addClass('bare-with-me-bundle');
          productMarkup.appendTo('#bundle-builder-app--bundle--root');

          // Change add to cart button
          $('.bundle-builder-app--bundle--add-to-cart-button').addClass('Button Button--primary Button--full');
          $('.bundle-builder-app--bundle--add-to-cart-button > span').text('Add to cart');

          // Add Swatch name tooltipsbundle-builder-app--bundle--add-to-cart-button
          $('li.bundle-builder-app--bundle--product').each(function() {
              var $this = $(this);
              var variantName = $this.find('.bundle-builder-app--bundle--product-name').text();
              $this.attr('data-tooltip', variantName);
          });

          // Make DOM adjustments
          //setTimeout(function(){
          // Fill in names
          $('[data-tp-fill="productName"]').text($('.bundle-builder-app--bundle--name').text());

          // Move into Product page template 
          $('.bundle-builder-app--summary--block').prependTo('.Product__Gallery');
          $('.bundle-builder-app--products--block').prependTo('.tp-bb-swatches');
          $('.bundle-builder-app--button-container').prependTo('.tp-bb-add-to-bag');
          $('.bundle-builder-app--bundle--price').last().prependTo('.tp-bb-price');

          var price = $('.bundle-builder-app--bundle--total-price').find('.money').text();
          $('.tp-bb-price').append('<afterpay-placement data-locale="en_US" data-currency="USD" data-logo-type="lockup" data-size="sm" data-amount="' + price.replace("$", "") + '"></afterpay-placement>');

          //}, 100);



          // Additional functionality
          // $('body').on('click', '.bundle-builder-app--bundle--product-add-button-added', function() {
          //   console.log(this);
          // });
      }
  } else {
      setTimeout(loadBundle, 100);
  }
}

$(document).ready(function() {
  //checkForGWP(false);
  getCountry();
  updatePricesForCurrency();
  //checkForRewardCurrency();

  if ($('.AnnouncementBar').length > 1 && !$('.AnnouncementBar--admin').length) {
      var announcements = $('#section-announcement');
      announcements.data('speed');
      announcements.flickity({
          autoPlay: announcements.data('speed'),
          wrapAround: true,
          freeScroll: false,
          pageDots: false
      });
  }

  if ($('.Section__tab-carousel').length) {
      var collapsibles = $('.Section__tab-carousel');
      collapsibles.flickity({
          autoPlay: false,
          wrapAround: false,
          freeScroll: false,
          pageDots: false,
          contain: true,
          groupCells: true
      });
  }

  if ($('.Product__Gallery').length) {
      //$(window).on('load', adjustProductMetaLayout);
      adjustProductMetaLayout();
      SPRCallbacks.onReviewsLoad = function() {
          adjustProductMetaLayout();
      }
      $(window).resize(adjustProductMetaLayout);
  }


  if (jQuery('#bundle-builder--shop').length) {
      loadBundle();
  }

  /* getting started js */
  if (screen.width < 600) {
      // $(document).ready(function(){
      $('.sc-BHvUt.fJlZte.pf-8_').html("Never Pay For Manicures Again!");
      $('.sc-BHvUt.fJlZte.pf-11_').html('Save $$$ every time, no UV light needed.');
      $('.sc-BHvUt.fJlZte.pf-23_').before('<h2 class="trustedby_text">Trusted by <b>384,237+</b> Happy Customers</h2>');
      $('.sc-hYQoXb.ctGkmz.pf-25_ img').attr("src", "https://cdn.shopify.com/s/files/1/0261/5354/9929/files/authority_logos_colorized.jpg?v=1666949784");
      $('.sc-hYQoXb.ctGkmz.pf-25_ img').attr("srcset", "https://cdn.shopify.com/s/files/1/0261/5354/9929/files/authority_logos_colorized.jpg?v=1666949784");
      $('.sc-BHvUt.fJlZte.pf-23_').html('AS SEEN ON:');
      // });
  }

  function showMenu(menuItem) {
      var parent = menuItem.parents('.Menu__NavContainer').first();
      var target = menuItem.data('target');
      parent.find('.Menu__LinkListItemLink--active').removeClass('Menu__LinkListItemLink--active');
      menuItem.addClass('Menu__LinkListItemLink--active');
      parent.find('.Menu__SubLinkListItemContainer').removeClass('Menu__SubLinkListItemContainer--active');
      parent.find('.Menu__SubLinkListItemContainer--' + target).addClass('Menu__SubLinkListItemContainer--active'); //.find('.Link--secondary').attr('tabindex', '-1');
  }

  $('.Menu__LinkListItemLink').mouseover(function() {
      showMenu($(this));
  });
  $('.Menu__LinkListItemLink').focus(function() {
      showMenu($(this));
  });

  if ($('#nav-image-data').length) {
      var nav_image_data = JSON.parse($('#nav-image-data').html());
      $('.Menu__SubLinkListItemImage').each(function() {
          var img = $(this);
          var key = img.data('key');
          var image = nav_image_data.images.find(r => {
              return r.key === key
          });
          if (image) {
              img.attr('src', image.img).attr('alt', image.alt);
          }
      });
  }

  $('.ProductMeta__Description .tab-content.ui-tabs-panel a').on('click', function(e) {
      e.preventDefault();
      window.location.href = this.href;
  });

});

//window.tpCheckForGWP = checkForGWP;

if (newUserBadgeEnabled) {
  function setCookie(c_name, value, exdays) {
      var exdate = new Date();
      exdate.setDate(exdate.getDate() + exdays);
      var c_value = escape(value) + ((exdays == null) ? "" : "; expires=" + exdate.toUTCString());
      document.cookie = c_name + "=" + c_value;
  }

  function getCookie(c_name) {
      var c_value = document.cookie;
      var c_start = c_value.indexOf(" " + c_name + "=");
      if (c_start == -1) {
          c_start = c_value.indexOf(c_name + "=");
      }
      if (c_start == -1) {
          c_value = null;
      } else {
          c_start = c_value.indexOf("=", c_start) + 1;
          var c_end = c_value.indexOf(";", c_start);
          if (c_end == -1) {
              c_end = c_value.length;
          }
          c_value = unescape(c_value.substring(c_start, c_end));
      }
      return c_value;
  }

  checkSession();

  function checkSession() {
      var c = getCookie("visited");

      if (c === "yes") {
          if (sessionStorage.getItem('visitedBefore') != "new") {
              sessionStorage.setItem('visitedBefore', "old");
          }
      } else {
          sessionStorage.setItem('visitedBefore', "new");
      }

      if (sessionStorage.getItem('visitedBefore') == "new") {
          console.log("New User");
          document.querySelectorAll('.ProductItem__Label.NewUser')?.forEach(item => {
              item.style.display = "block";
          });
          setCookie("visited", "yes", 365);
      }
  }

} else {
  console.log("Disabled the option for New User Badge.")
}

function countdown(dateEnd) {
  var timer, days, hours, minutes, seconds;

  dateEnd = new Date(dateEnd);
  dateEnd = dateEnd.getTime();

  if (isNaN(dateEnd)) {
      return;
  }

  timer = setInterval(calculate, 1000);

  function calculate() {
      var dateStart = new Date();
      var dateStart = new Date(dateStart.getUTCFullYear(),
          dateStart.getUTCMonth(),
          dateStart.getUTCDate(),
          dateStart.getUTCHours(),
          dateStart.getUTCMinutes(),
          dateStart.getUTCSeconds());
      var timeRemaining = parseInt((dateEnd - dateStart.getTime()) / 1000)

      if (timeRemaining >= 0) {
          days = parseInt(timeRemaining / 86400);
          timeRemaining = (timeRemaining % 86400);
          hours = parseInt(timeRemaining / 3600);
          timeRemaining = (timeRemaining % 3600);
          minutes = parseInt(timeRemaining / 60);
          timeRemaining = (timeRemaining % 60);
          seconds = parseInt(timeRemaining);

          // document.getElementById("days").innerHTML    = parseInt(days, 10);
          // document.getElementById("hours").innerHTML   = ("0" + hours).slice(-2);
          document.getElementById("minutess").innerHTML = ("0" + minutes).slice(-2);
          document.getElementById("secondss").innerHTML = ("0" + seconds).slice(-2);
      } else {
          return;
      }
  }

  function display(days, hours, minutes, seconds) {}
}

function dateAdd(date, interval, units) {
  if (!(date instanceof Date))
      return undefined;
  var ret = new Date(date); //don't change original date
  var checkRollover = function() {
      if (ret.getDate() != date.getDate()) ret.setDate(0);
  };
  switch (String(interval).toLowerCase()) {
      case 'year':
          ret.setFullYear(ret.getFullYear() + units);
          checkRollover();
          break;
      case 'quarter':
          ret.setMonth(ret.getMonth() + 3 * units);
          checkRollover();
          break;
      case 'month':
          ret.setMonth(ret.getMonth() + units);
          checkRollover();
          break;
      case 'week':
          ret.setDate(ret.getDate() + 7 * units);
          break;
      case 'day':
          ret.setDate(ret.getDate() + units);
          break;
      case 'hour':
          ret.setTime(ret.getTime() + units * 3600000);
          break;
      case 'minute':
          ret.setTime(ret.getTime() + units * 60000);
          break;
      case 'second':
          ret.setTime(ret.getTime() + units * 1000);
          break;
      default:
          ret = undefined;
          break;
  }
  return ret;
}

function padTo2Digits(num) {
  return num.toString().padStart(2, '0');
}

function formatDate(date) {
  return (
      [
          date.getFullYear(),
          padTo2Digits(date.getMonth() + 1),
          padTo2Digits(date.getDate()),
      ].join('-') +
      ' ' + [
          padTo2Digits(date.getHours()),
          padTo2Digits(date.getMinutes()),
          padTo2Digits(date.getSeconds()),
      ].join(':')
  );
}
let date = formatDate(new Date());
// let countdownDate = dateAdd(d, 'minute', 10);
// console.log(countdownDate, formatDate(new Date()));
// countdown(countdownDate);
let d = new Date(date);
console.log(date, d, 'date');
console.log(dateAdd(d, 'minute', 10), 'dateAdd(d, minute, 1)');
// let d = Date.now();
let countdownDate = dateAdd(d, 'minute', 10);
// console.log(d.toString(), countdownDate, 'countdownDate');

// d = new Date('2016-02-29 12:00:00');
countdown(countdownDate);

let countdownWrapper = document.querySelector('.countdown');

setTimeout(() => {
  countdownWrapper.classList.add('show');
}, 1000);